import { compose, withHandlers, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import {
  getBarberDaysOffAsDates,
  getBarberDaysOnAsDates,
  getBarberWeekdaysOff,
  getBarberByIdOrRoute,
} from '../../barbers/selectors';
import { getShopWeekdaysOff } from '../../shops/selectors';
import WithAnyBarber from '../../hoc/WithAnyBarber';
import WithAdvanceBookDays from '../../hoc/WithAdvanceBookDays';
import DateSlider from '../components/DateSlider';
import { getDaysUpToAdvanceBookDays } from '../selectors';
import * as reservationSelectors from '../../reservation/selectors';
import { fetchDaysOff } from '../../daysOff/actions';

const DateSliderContainer = compose(
  withRouter,
  WithAdvanceBookDays,
  WithAnyBarber,
  connect(
    (state, ownProps) => ({
      barber: getBarberByIdOrRoute(state, ownProps.params.barberRoute),
      days: getDaysUpToAdvanceBookDays(state, ownProps.advanceBookDays),
      updatedAt: state.times.updatedAt,
      daysOff: ownProps.params.barberRoute
        ? getBarberDaysOffAsDates(state)
        : reservationSelectors.getBarberDaysOffAsDates(state),
      daysOn: ownProps.params.barberRoute
        ? getBarberDaysOnAsDates(state, ownProps.params.barberRoute)
        : reservationSelectors.getBarberDaysOnAsDates(state),
      weekdaysOff: (() => {
        if (!ownProps.params.barberRoute) {
          return reservationSelectors.getBarberWeekdaysOff(state);
        }
        if (ownProps.anyBarber) {
          return getShopWeekdaysOff(state, ownProps.params.shopRoute);
        }
        return getBarberWeekdaysOff(state, ownProps.params.barberRoute);
      })(),
    }),
    {
      fetchDaysOff,
    },
  ),
  withHandlers({
    onDayClick: props => day => () => props.setActiveDay(day),
    fetch: props => () => props.barber && props.fetchDaysOff(props.barber),
  }),
  withPropsOnChange(
    (props, nextProps) => props.barber && props.barber !== nextProps.barber,
    props => props.fetch(),
  ),
)(DateSlider);

export default DateSliderContainer;



// WEBPACK FOOTER //
// ./src/app/times/containers/DateSlider.js